import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PlatformLogo from "@/components/PlatformLogo";
import { http, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import LanguageSelector from "@/components/LanguageSelector";
import { Loader2, ArrowLeft, MailCheck, KeyRound } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await http.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (er) { setSent(true); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F172A] p-6" data-testid="forgot-page">
      <div className="absolute top-4 right-4"><LanguageSelector /></div>
      <div className="w-full max-w-sm bg-white rounded-2xl p-6">
        <div className="mb-4"><PlatformLogo size={32} dark={false} testId="forgot-platform-logo" /></div>
        <div className="flex items-center gap-2 mb-1"><KeyRound className="w-5 h-5 text-sky-600" /><h1 className="font-heading text-xl font-bold text-[#0F172A]">{t("auth.forgot_title")}</h1></div>
        {sent ? (
          <div className="mt-4 text-center space-y-4" data-testid="forgot-sent">
            <MailCheck className="w-12 h-12 text-emerald-500 mx-auto" />
            <p className="text-sm text-slate-600">{t("auth.forgot_sent")}</p>
            <Link to="/login"><Button variant="outline" className="gap-1.5"><ArrowLeft className="w-4 h-4" /> {t("auth.back_login")}</Button></Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-3">
            <p className="text-sm text-slate-500">{t("auth.forgot_sub")}</p>
            <div><Label htmlFor="fp-email">{t("auth.email")}</Label>
              <Input id="fp-email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" /></div>
            <Button type="submit" data-testid="forgot-submit" disabled={busy || !email} className="w-full h-11 bg-[#0F172A] hover:bg-[#1E293B]">
              {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} {t("auth.send_reset")}
            </Button>
            <Link to="/login" className="block text-center text-sm text-slate-500 hover:text-slate-700">{t("auth.back_login")}</Link>
          </form>
        )}
      </div>
    </div>
  );
}
